import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";

const TermsAndConditions = () => {
  return (
    <>
    <Navbar/>
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Terms & Conditions</h1>
        <p style={styles.date}>Effective Date: 29/06/2025</p>
      </div>

      <div style={styles.content}>
        {sections.map((section, i) => (
          <div key={i} style={styles.card}>
            <h2 style={styles.sectionTitle}>{section.title}</h2>
            <p style={styles.sectionText}>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </>
  );
};

const sections = [
  {
    title: "1. Website Purpose",
    text:
      "The Pearl Tours and Travels website is intended solely for informational purposes. It provides users with an overview of the travel packages, destination highlights, and visa guidance offered by our agency. While we aim to present comprehensive and engaging travel details, please note that this platform does not facilitate online bookings, payments, or any kind of financial transaction.",
  },
  {
    title: "2. Information Accuracy",
    text:
      "All information displayed on this website is curated with the intent to be accurate and up-to-date. However, travel details such as visa requirements, tour inclusions, pricing, and availability are subject to change without notice. Pearl Tours and Travels does not assume responsibility for any discrepancies, outdated content, or errors. We recommend users verify critical information directly with our team or relevant travel authorities before making any decisions.",
  },
  {
    title: "3. No Online Booking or Payment",
    text:
      "Currently, our website does not support online booking or payment systems. All bookings, confirmations, and inquiries must be handled through direct communication with our staff via phone, email, or in-person visits. Any form submissions or contact forms on the website are intended solely for initial inquiries, and do not constitute a binding agreement or reservation.",
  },
  {
    title: "4. Intellectual Property",
    text:
      "All materials on this website — including but not limited to text, images, logos, design elements, and videos — are the intellectual property of Pearl Tours and Travels. Unauthorized copying, downloading, reproduction, or redistribution of any content without our express written permission is strictly prohibited. Violators may be subject to legal action under applicable copyright laws.",
  },
  {
    title: "5. External Links",
    text:
      "Our website may contain links to third-party websites for the convenience of our users. These may include airline partners, visa portals, or travel blogs. Pearl Tours and Travels is not responsible for the content, accuracy, or policies of these external sites. Visiting linked sites is done at your own risk, and we encourage users to review their terms and privacy policies separately.",
  },
  {
    title: "6. Contact Information",
    text:
      "For any queries, clarifications, or assistance regarding our services, users may reach us through the following channels:\n\nEmail: pearltoursandtravelsangli@gmail.com\nMobile: +91-73034 55505\nLandline: 0233-2305955\n\nOur customer support team is available 24/7 to assist with travel planning, inquiries, and feedback. We aim to respond to all email communications within 24 hours.",
  },
];

const styles = {
  page: {
    backgroundColor: "white",
    minHeight: "100vh",
    padding: "40px 20px",
    color: "#fff",
    fontFamily: "Segoe UI, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
  },
  title: {
    color: "#64192E",
    fontSize: "36px",
    marginBottom: "10px",
  },
  date: {
    color: "#ccc",
    fontSize: "14px",
  },
  content: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#ccc",
    padding: "25px",
    borderRadius: "12px",
    marginBottom: "20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
    transition: "transform 0.2s",
  },
  sectionTitle: {
    fontSize: "20px",
    color: "#64192E",
    marginBottom: "10px",
  },
  sectionText: {
    fontSize: "16px",
    color: "black",
  },
};

export default TermsAndConditions;
